import { AuthService } from '../auth/auth.service';
import { SharedService } from '../shared/shared.service';
import { OrderService } from '../order/shared/order.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-dashboard',
    templateUrl: './full-layout.component.html',
})
export class FullLayoutComponent implements OnInit {
    public user: any;
    public disabled = false;
    public status: { isopen: boolean } = { isopen: false };
    productGroups;
    devstatusOptions: any = {
        wrikeFolder: 'IEAAUGREI4ECQMK7',
        wrikeStatus: 'inprogress',
        repo: 'kundeportal',
        coreui: true,
        wrikeKey: '',
        bitbucketUser: '',
        bitbucketPass: ''
    };
    shoppingCartLength;
    env: any;

    constructor(
        public auth: AuthService,
        public sharedService: SharedService,
        public orderService: OrderService
    ) {
        // this.getDevstatusKeys();
    }

    ngOnInit(): void {
        this.user = JSON.parse(localStorage.getItem('user'));
    }

    

    public getDevstatusKeys() {
        this.sharedService.getEnv().subscribe(res => {
            this.env = res;
            this.devstatusOptions.wrikeKey = this.env.wrike.key;
            this.devstatusOptions.bitbucketUser = this.env.bitbucket.user;
            this.devstatusOptions.bitbucketPass = this.env.bitbucket.key;
        });
    }

    public toggled(open: boolean): void {
    }

    public toggleDropdown($event: MouseEvent): void {
        $event.preventDefault();
        $event.stopPropagation();
        this.status.isopen = !this.status.isopen;
    }

    selectProductGroup(id) {
        this.sharedService.selectProductGroup(id);
    }
}




// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts